/**
 * Wires up lister filters, pagination, and AJAX updates.
 * @param {import('jquery')} $
 */
const postFilters = ($) => {
    let currentRequest = null;
    const $postsGrid = $('#posts-grid');
    const $loadMoreWrapper = $('.lister-load-more');
    const $loadMoreButton = $('.lister-load-more__button');
    const mobileMediaQuery = window.matchMedia('(max-width: 46.1875rem)');

    const isMobileFilters = () => mobileMediaQuery.matches;

    const getActiveFilters = () => {
        const termIdsByType = {};

        $('.lister-filter__checkboxes').each(function () {
            const $group = $(this);
            const termType = $group.data('term_type');
            const selectedValues = $group.find('.lister-filter__checkbox-input:checked').map(function () {
                return $(this).val();
            }).get();

            if (!termType || !selectedValues.length) {
                return;
            }

            termIdsByType[termType] = selectedValues;
        });

        return termIdsByType;
    };

    const updateFilterState = () => {
        const hasSelection = $('.lister-filter__checkbox-input:checked').length > 0;
        $('.lister-filters').toggleClass('has-selection', hasSelection);
    };

    const updatePaginationState = (currentPage, maxPages) => {
        const safeCurrentPage = Number.isInteger(currentPage) ? currentPage : 1;
        const safeMaxPages = Number.isInteger(maxPages) ? maxPages : 1;
        const hasMore = safeMaxPages > safeCurrentPage;

        $postsGrid.data('current-page', safeCurrentPage);
        $postsGrid.data('max-pages', safeMaxPages);
        $loadMoreWrapper.toggleClass('is-hidden', !hasMore);
        $loadMoreButton.prop('disabled', !hasMore);
    };

    const fetchPosts = ({ append = false, page = 1 } = {}) => {
        if (currentRequest) {
            currentRequest.abort();
        }

        $postsGrid.addClass('is-loading');
        $loadMoreButton.prop('disabled', true);

        const queryParams = new URLSearchParams();
        const perPage = $postsGrid.data('per-page');
        const postType = $postsGrid.data('post-type');
        const searchTerm = $postsGrid.data('search-term');
        const activeFilters = getActiveFilters();

        Object.keys(activeFilters).forEach((termType) => {
            queryParams.append(termType, activeFilters[termType].join(','));
        });

        if (perPage) {
            queryParams.append('perPage', perPage);
        }

        if (postType) {
            queryParams.append('postType', postType);
        }

        if (searchTerm) {
            queryParams.append('s', searchTerm);
        }

        if (page) {
            queryParams.append('paged', page);
        }

        if (wpApiSettings.lang) {
            queryParams.append('lang', wpApiSettings.lang);
        }

        const queryString = queryParams.toString() ? `?${queryParams.toString()}` : '';

        currentRequest = $.ajax({
            url: `${wpApiSettings.root}wp/v2/posts-tax${queryString}`,
            method: 'GET',
            beforeSend: function (xhr) {
                xhr.setRequestHeader('X-WP-Nonce', wpApiSettings.nonce);
            }
        })
            .done(function (response) {
                const responseHtml = response && response.html ? response.html : '';
                const nextMaxPages = parseInt(response && response.max_pages, 10);
                const nextCurrentPage = parseInt(response && response.current_page, 10);

                setTimeout(() => {
                    if (append) {
                        $postsGrid.append(responseHtml);
                    } else {
                        $postsGrid.html(responseHtml);
                    }
                }, 1000);

                updatePaginationState(nextCurrentPage, nextMaxPages);
            })
            .always(function () {
                currentRequest = null;
                setTimeout(() => {
                    $postsGrid.removeClass('is-loading');
                }, 1000);
                const currentPage = parseInt($postsGrid.data('current-page'), 10);
                const maxPages = parseInt($postsGrid.data('max-pages'), 10);
                updatePaginationState(currentPage, maxPages);
            });
    };

    const resetFilters = () => {
        $('.lister-filter__checkbox-input').prop('checked', false);
        updateFilterState();
        fetchPosts({ page: 1 });
    };

    const updateGroupCount = ($group) => {
        const count = $group.find('.lister-filter__checkbox-input:checked').length;
        const $count = $group.find('.lister-filter__count');
        if ($count.length) {
            $count.text(count ? `(${count})` : '');
        }
    };

    const closeAllDropdowns = () => {
        $('.lister-filter__group').each(function () {
            const $group = $(this);
            const $toggle = $group.find('.lister-filter__toggle');
            const $dropdown = $group.find('.lister-filter__dropdown');
            $group.removeClass('is-open');
            $toggle.attr('aria-expanded', 'false');
            $dropdown.attr('hidden', 'hidden');
        });
    };

    $(document).on('click', '.lister-filter__toggle', function () {
        const $toggle = $(this);
        const $group = $toggle.closest('.lister-filter__group');
        const $dropdown = $group.find('.lister-filter__dropdown');
        const isOpen = $group.hasClass('is-open');

        if (!isMobileFilters()) {
            closeAllDropdowns();
        }

        if (isOpen) {
            $group.removeClass('is-open');
            $toggle.attr('aria-expanded', 'false');
            $dropdown.attr('hidden', 'hidden');
            return;
        }

        if (!isOpen) {
            $group.addClass('is-open');
            $toggle.attr('aria-expanded', 'true');
            $dropdown.removeAttr('hidden');
        }
    });

    $(document).on('click', function (e) {
        if (isMobileFilters()) {
            return;
        }

        if (!$(e.target).closest('.lister-filter__group').length) {
            closeAllDropdowns();
        }
    });

    $(document).on('click', '.lister-filter__apply-button', function (e) {
        e.preventDefault();
        fetchPosts({ page: 1 });
    });

    $(document).on('click', '.lister-filter__reset-button', function (e) {
        e.preventDefault();
        resetFilters();
    });

    $(document).on('change', '.lister-filter__checkbox-input', function () {
        const $checkbox = $(this);
        const $group = $checkbox.closest('.lister-filter__checkboxes');
        const termType = $group.data('term_type');
        const selectedValues = $group.find('.lister-filter__checkbox-input:checked').map(function () {
            return $(this).val();
        }).get();
        updateGroupCount($group.closest('.lister-filter__group'));
        updateFilterState();
    });

    $(document).on('click', '.lister-load-more__button', function (e) {
        e.preventDefault();
        const currentPage = parseInt($postsGrid.data('current-page'), 10) || 1;
        const maxPages = parseInt($postsGrid.data('max-pages'), 10) || 1;
        if (currentPage >= maxPages) {
            updatePaginationState(currentPage, maxPages);
            return;
        }

        fetchPosts({ append: true, page: currentPage + 1 });
    });

    updateFilterState();

    if ($postsGrid.length) {
        const initialCurrentPage = parseInt($postsGrid.data('current-page'), 10);
        const initialMaxPages = parseInt($postsGrid.data('max-pages'), 10);
        updatePaginationState(initialCurrentPage, initialMaxPages);
    }

    $('.lister-filter__group').each(function () {
        const $group = $(this);
        const $dropdown = $group.find('.lister-filter__dropdown');
        updateGroupCount($group);
        $dropdown.attr('hidden', 'hidden');
    });
};

export default postFilters;
